import { BASE_URL } from "./MainApi";

export const getCourseProgress = async (courseSlug) => {
  const token = localStorage.getItem("token");

  const [lastRes, progressRes] = await Promise.all([
    fetch(`${BASE_URL}/progress/last/${courseSlug}`, {
      headers: { Authorization: `Bearer ${token}`}
    }),
    fetch(`${BASE_URL}/progress/me/${courseSlug}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
  ]);
  
  const lastLesson = await lastRes.json();
  const courseProgress = await progressRes.json();

  return { lastLesson, courseProgress};
};

export const saveLessonProgress = async (data) => {
  const token = localStorage.getItem("token");

  const res = await fetch(`${BASE_URL}/progress`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });

  return res.json();
}
